<!-- Tab -->
<script lang="ts" setup generic="TValue">
import { computed } from 'vue';
import { LayoutOrientation } from '../Enums/UiEnums';

    const horizontalSelected    = "shadow-none rounded-0 border-top-0 border-start-0 border-end-0 btn btn-outline-primary border-2";
    const horizontal            = "shadow-none rounded-0 border-top-0 border-start-0 border-end-0 btn btn-outline-secondary border-light";
    const vertialSelected       = "shadow-none rounded-0 border-top-0 border-start-0 border-bottom-0 btn btn-outline-primary border-2";
    const vertical              = "shadow-none rounded-0 border-top-0 border-start-0 border-bottom-0 btn btn-outline-secondary border-light";

    const props = defineProps<{
        modelValue?: TValue,   // Use with v-model
        value?: TValue,         // Value assocaited with the tab button selection
        layout?: LayoutOrientation,
        disabled?: boolean,
        width?: number
    }>();

    const emit = defineEmits<{
        (e: "onChange", selectedItem: TValue|undefined):void,
        (e: "update:model-value", selectedItem: TValue|undefined):void,
    }>();

    function EmitEleValue(evt: Event)
    {
        if (props.disabled)
            return;

        emit("update:model-value", props.value);
        emit("onChange", props.value);
    }

    const layoutMode = computed<LayoutOrientation>(() => props.layout ?? LayoutOrientation.Vert);
    const layoutClass = computed<string>(() => LayoutOrientation.Vert == layoutMode.value ? vertical : horizontal);
    const layoutSelectedClass = computed<string>(() => LayoutOrientation.Vert == layoutMode.value ? vertialSelected : horizontalSelected);
    const buttonClass = computed<string>(() => props.modelValue == props.value ? layoutSelectedClass.value : layoutClass.value);
    const buttonStyle = computed<string>(() => (props.width ?? 0) > 0 ? `width: ${props.width}px` : "");

</script>
<template>
    <button type="button" @click="EmitEleValue" :class="buttonClass" :style="buttonStyle">
        <slot></slot>
        <slot name="marker">
        </slot>
    </button>
</template>